const ResultsPerPage = [
  10,
  20,
  50
]

export default ResultsPerPage;